// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-cell[data-v-1d11af3a] {\n  background-color: var(--white);\n}\n.number-input[data-v-1d11af3a] {\n  width: 100%;\n  height: 100%;\n  padding: 1px 2px;\n  outline: none;\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
